import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useFormik } from "formik";
import * as yup from "yup";
import payrateIcon from "../images/payrateIcon.svg";
import moment from "moment";
import { useLocation, Link, useNavigate } from "react-router-dom";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import InvoiceDisplay from "./InvoiceDisplay";
import LoaderForm from "./LoaderForm";
import "../styles/GenerateInvoice.css";
import DefaultEmployeeProfile from "../images/DefaultEmployeeProfile.svg";
import startingDateIcon from "../images/startingDateIcon.svg";
import endingDateIcon from "../images/endingDateIcon.svg";
import additionsIcon from "../images/additionsIcon.svg";
import deductionsIcon from "../images/deductionsIcon.svg";
import hoursWorkedIcon from "../images/hoursWorkedIcon.svg";
import minutesWorkedIcon from "../images/minutesWorkedIcon.svg";
import propertyIcon from "../images/propertyIcon.svg";
import salaryIcon from "../images/salaryIcon.svg";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAuth } from "../auth/auth";
import { PERMISSIONS } from "../utils/rbac";
import { usePermissionGuard } from "../hooks/usePermissionGuard";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { formatDisplayDate } from "../utils/displayDate";
const apiUrl = process.env.REACT_APP_API_URL;

const GenerateInvoice = () => {
  useAuth();
  const navigate = useNavigate();
  const { guardAction, PermissionDialog, isAllowed } = usePermissionGuard();
  const canGeneratePayslip = isAllowed(PERMISSIONS.CREATE_PAYSLIP);

  useEffect(() => {
    if (!canGeneratePayslip) {
      guardAction(PERMISSIONS.CREATE_PAYSLIP, "generate payslip");
      navigate("/dashboard", { replace: true });
    }
  }, [canGeneratePayslip, guardAction, navigate]);

  const [user, setUser] = useState({});
  const [employees, setEmployees] = useState([]);
  const [id, setUserIdState] = useState();
  const [userId, setuserId] = useState();
  const [imageURL, setImageURL] = useState("");
  const [selectOpen, setSelectOpen] = useState(false);
  const [invoiceId, setInvoiceId] = useState(null);
  const [existingInvoiceId, setExistingInvoiceId] = useState(null);
  const loadedInvoiceIdRef = useRef(null);
  const existingLookupRef = useRef(0);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const startDatePickerRef = useRef(null);
  const endDatePickerRef = useRef(null);
  const [formDataList, setFormDataList] = useState([]);
  const [additionsType, setAdditionsType] = useState("");
  const [choosedRate, setChoosedRate] = useState("");
  const [deductionsType, setdeductionsType] = useState("");
  const [property, setProperty] = useState("");
  const [btnText, setBtnText] = useState("Add");
  const [propertyList, setPropertyList] = useState([]);
  const [additionsTypeList, setAdditionsTypeList] = useState([]);
  const [userRates, setUserRates] = useState([]);
  const [deductionssTypeList, setDeductionssTypeList] = useState([]);
  const [editedIndex, setEditedIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [isOpenEndDate, setIsOpenEndDate] = useState(false);

  const location = useLocation();
  // Employee preselected from Manage Employees; the only one allowed to open
  // an existing payslip for the period from this page.
  const [profileEmployeeId, setProfileEmployeeId] = useState(null);
  useEffect(() => {
    if (location.state) {
      setUserIdState(location.state);
      setProfileEmployeeId(location.state);
    }
  }, [location.state]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const startDateParam = params.get('startDate');
  //   const endDateParam = params.get('endDate');

  //   // if (startDateParam && endDateParam) {
  //   //   setStartDate(new Date(startDateParam));
  //   //   setEndDate(new Date(endDateParam));
  //   // }
  // }, [location.search]);

  useEffect(() => {
    if (id) {
      const fetchUserDetails = async () => {
        try {
          const response = await axios.post(`${apiUrl}/getEmployeeDetail`, {
            id: id,
          });
          setUser(response.data.data);
          const userData = response.data.data;
          const uniqueRates = [
            {
              key: "primary",
              title: "Pay Rate",
              rate: userData.payRate,
            },
            {
              key: "secondary",
              title: "Secondary Pay Rate",
              rate: userData.secondaryPayRate,
            },
            {
              key: "tertiary",
              title: "Tertiary Pay Rate",
              rate: userData.tertiaryPayRate,
            },
          ].filter(
            ({ rate }) => rate !== null && rate !== undefined && rate !== ""
          );
          const ratesList = uniqueRates.map(({ key, title, rate }) => ({
            key,
            title,
            label: `${title} - $${parseFloat(rate).toFixed(2)} / hr`,
            selectedLabel: `$${parseFloat(rate).toFixed(2)} / hr`,
            value: parseFloat(rate),
          }));

          setUserRates(ratesList);
          if (ratesList.length > 0) {
            const lastPayslipRate = parseFloat(userData.lastPayslipRate);
            const matchedLastRate = ratesList.find(
              (rateOption) =>
                Number(rateOption.value) === lastPayslipRate
            );
            const selectedRate = matchedLastRate || ratesList[0];
            setChoosedRate(selectedRate.value);
            formik.setFieldValue("choosedRate", selectedRate.value);
          }
          setuserId(response.data.data.id);
          setImageURL(response.data.data.image);
        } catch (error) {
          //console.error("Failed to fetch user details:", error);
        }
      };

      fetchUserDetails();
    }
  }, [id]);

  const showMessage = (text) => {
    setMessage(text);

    // Hide the message after 2000 milliseconds (2 seconds)
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  const handleRadioClick = (newValue) => {
    formik.setValues({
      ...formik.values,
      paymentType: newValue,
    });
  };

  const shouldApplyFilledClass = (value) => {
    return value !== undefined && value !== null && value !== "";
  };

  const handleKeyDown = (event) => {
    // Allow only numbers, backspace, delete, arrow keys, and decimal point
    const allowedChars = /[0-9\b\t\r\f\v\↓\↑\→\←\.\.]/;
    if (!allowedChars.test(event.key) && event.key !== "Backspace") {
      event.preventDefault();
    }
  };

  function formatInvoiceAdditions(additions) {
    const numericValue = Number(additions);
    if (Number.isNaN(numericValue)) {
      return "0.00";
    }
    return numericValue.toFixed(2);
  }

  const handleWheel = (e) => {
    // Prevent the input value change
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  const handleDeleteEntry = (index) => {
    // Create a copy of formDataList
    const updatedFormDataList = [...formDataList];
    // Remove the entry at the specified index
    updatedFormDataList.splice(index, 1);
    // Update the state with the new list
    setFormDataList(updatedFormDataList);
  };

  const handleEditEntry = (index) => {
    const editedFormData = formDataList[index];
    if (!editedFormData) return;

    const parseMaybeDate = (value) => {
      if (!value) return "";
      const parsed = value instanceof Date ? value : new Date(value);
      return Number.isNaN(parsed.getTime()) ? "" : parsed;
    };

    const newFormValues = {
      payFromDate: parseMaybeDate(editedFormData.payFromDate),
      payToDate: parseMaybeDate(editedFormData.payToDate),
      Additions: editedFormData.Additions,
      Deductions: editedFormData.Deductions,
      paymentType: editedFormData.paymentType || "hourly",
      hours: editedFormData.hours ?? "",
      minutes: editedFormData.minutes ?? "",
      salary: editedFormData.salary ?? "",
      choosedRate: "",
    };

    if (editedFormData.paymentType === "salary") {
      newFormValues.salary = editedFormData.salary;
    } else {
      newFormValues.hours = editedFormData.hours ?? 0;
      newFormValues.minutes = editedFormData.minutes ?? 0;
      if (
        editedFormData.hourlyRate !== undefined &&
        editedFormData.hourlyRate !== null &&
        editedFormData.hourlyRate !== ""
      ) {
        newFormValues.choosedRate = parseFloat(editedFormData.hourlyRate);
        setChoosedRate(newFormValues.choosedRate);
      }
    }

    setAdditionsType(editedFormData.additionsType || "");
    setdeductionsType(editedFormData.deductionsType || "");
    setProperty(editedFormData.property || "");
    formik.setValues(newFormValues);
    setEditedIndex(index);
    setBtnText("Update");
  };

  const handleDataSubmission = async () => {
    if (!id) {
      showMessage("Please select a user.");
      return;
    }
    if (
      formik.values.payFromDate === "" ||
      formik.values.payFromDate === undefined
    ) {
      showMessage("Please choose starting date.");
      return;
    }
    if (
      formik.values.payToDate === "" ||
      formik.values.payToDate === undefined
    ) {
      showMessage("Please choose ending date.");
      return;
    }

    if (formDataList.length === 0) {
      showMessage("Please add a record.");
      return;
    }

    const params = new URLSearchParams(location.search);
    const rangeId = params.get("rangeId");
    const startDateParam = params.get("startDate");

    const values = {
      userId,
      payDateId: rangeId,
      startDate: startDateParam,
      email: user.email,
      payToDateInput: convertDateFormat(formik.values.payToDate.toString()),
      payFromDateInput: convertDateFormat(formik.values.payFromDate.toString()),
      formDataList,
    };
    const isUpdate = Boolean(existingInvoiceId);
    if (isUpdate) {
      values.invoiceId = existingInvoiceId;
    }

    setLoading(true);
    // console.log(values);

    try {
      const response = await axios.post(
        `${apiUrl}/${isUpdate ? "editGenerateInvoice" : "newGenerateInvoice"}`,
        values
      );
      const data = response.data;
      if (response.status === 200) {
        if (data.status === 1) {
          setInvoiceId(data.data.id);
          setUserIdState();
          setUser({});
          setuserId();
          setImageURL("");
          fetchEmployees();
          setFormDataList([]);
          loadedInvoiceIdRef.current = null;
          setExistingInvoiceId(null);
          setProfileEmployeeId(null);
          showMessage(isUpdate ? "Payslip updated successfully" : data.message);
        } else {
          showMessage("Error: " + data.message);
        }
      } else {
        showMessage("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      showMessage(
        error.response?.data?.message
          ? "Error: " + error.response.data.message
          : "An error occured"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAddData = () => {
    // Add current form data to the list
    if (!id) {
      showMessage("Please select a user.");
      return;
    }

    if (
      formik.values.payFromDate === "" ||
      formik.values.payFromDate === undefined
    ) {
      showMessage("Please choose starting date.");
      return;
    }
    if (
      formik.values.payToDate === "" ||
      formik.values.payToDate === undefined
    ) {
      showMessage("Please choose ending date.");
      return;
    }
    if (
      new Date(formik.values.payFromDate) > new Date(formik.values.payToDate)
    ) {
      showMessage("Please enter valid start date.");
      return;
    }
    if (property === "") {
      showMessage("Please select property.");
      return;
    }

    if (
      formik.values.paymentType === "" ||
      formik.values.paymentType === undefined
    ) {
      showMessage("Please select hourly, salary or overtime.");
      return;
    }

    if (formik.values.paymentType === "hourly") {
      const { hours, minutes } = formik.values;

      if (hours === "" || hours === undefined) {
        showMessage("Please enter hours worked.");
        return;
      }

      if (!Number.isInteger(Number(hours))) {
        showMessage("Hours must be a integer number not in decimal.");
        return;
      }

      if (minutes !== "" && minutes !== undefined) {
        if (!Number.isInteger(Number(minutes))) {
          showMessage("Minutes must be a integer number not in decimal.");
          return;
        }

        if (minutes < 0 || minutes > 59) {
          showMessage("Please enter minutes between 0–59.");
          return;
        }
      }
    }

    if (formik.values.paymentType === "overtime") {
      const { hours, minutes } = formik.values;

      if (hours === "" || hours === undefined) {
        showMessage("Please enter hours worked.");
        return;
      }

      if (!Number.isInteger(Number(hours))) {
        showMessage("Hours must be a integer number not in decimal.");
        return;
      }

      if (minutes !== "" && minutes !== undefined) {
        if (!Number.isInteger(Number(minutes))) {
          showMessage("Minutes must be a integer number not in decimal.");
          return;
        }

        if (minutes < 0 || minutes > 59) {
          showMessage("Please enter minutes between 0–59.");
          return;
        }
      }
    }

    if (
      formik.values.paymentType === "hourly" ||
      formik.values.paymentType === "overtime"
    ) {
      if (
        formik.values.choosedRate === "" ||
        formik.values.choosedRate === undefined
      ) {
        showMessage("Please select payRate.");
        return;
      }
    }

    if (formik.values.paymentType === "salary") {
      if (formik.values.salary === "" || formik.values.salary === undefined) {
        showMessage("Please enter employee salary.");
        return;
      }
    }

    const formDataWithDeductionsType = {
      ...formik.values,
      deductionsType: deductionsType,
      additionsType: additionsType,
      property: property,
      hourlyRate:
        formik.values.choosedRate !== undefined
          ? formik.values.choosedRate
          : user.payRate,
    };

    // Check if minutes is an empty string or undefined, and set it to 0 if true
    if (formik.values.minutes === "" || formik.values.minutes === undefined) {
      formDataWithDeductionsType.minutes = 0;
    }

    if (additionsType !== "") {
      if (
        formik.values.Additions === "" ||
        formik.values.Additions === undefined
      ) {
        showMessage("Please enter addition amount.");
        return;
      }
      if (formik.values.Additions == 0) {
        showMessage("Please enter valid addition amount.");
        return;
      }
    }

    if (deductionsType !== "") {
      if (
        formik.values.Deductions === "" ||
        formik.values.Deductions === undefined
      ) {
        showMessage("Please enter deduction amount.");
        return;
      }
      if (formik.values.Deductions == 0) {
        showMessage("Please enter valid deduction amount.");
        return;
      }
    }

    if (
      formik.values.Additions === "" ||
      formik.values.Additions === undefined ||
      formik.values.Additions === 0
    ) {
      formDataWithDeductionsType.Additions = 0;
    } else {
      if (additionsType === "") {
        showMessage("Please select addition type.");
        return;
      }
    }

    if (
      formik.values.Deductions === "" ||
      formik.values.Deductions === undefined ||
      formik.values.Deductions === 0
    ) {
      formDataWithDeductionsType.Deductions = 0;
    } else {
      if (deductionsType === "") {
        showMessage("Please select deduction type.");
        return;
      }
    }

    if (editedIndex !== null) {
      setFormDataList((prev) => {
        const copy = [...prev];
        copy[editedIndex] = formDataWithDeductionsType;
        return copy;
      });
      setEditedIndex(null);
      setBtnText("Add");
    } else {
      setFormDataList((prevFormDataList) => [
        ...prevFormDataList,
        formDataWithDeductionsType,
      ]);
    }

    const payFromDate = formik.values.payFromDate;
    const payToDate = formik.values.payToDate;
    formik.resetForm();

    formik.setValues({
      //...formik.values,
      Additions: "",
      Deductions: "",
      salary: "",
      hours: "",
      // choosedRate:userRates[0].value,
      payFromDate: payFromDate,
      payToDate: payToDate,
    });

    // formik.setFieldValue("choosedRate", userRates[0].value);

    // Clear form fields other than start date, end date, and radio checkbox
    // Create a new object for form values with cleared fields
    // const newFormValues = {
    //   payFromDate:formik.values.payFromDate,
    //   payToDate: formik.values.payToDate,
    //   payRate: "",
    //   hours: "",
    //   Additions: "",
    //   Deductions: "",
    //   salary: "",
    // };

    setAdditionsType("");
    setdeductionsType("");
    setProperty("");
    setBtnText("Add");

    if (userRates.length > 0) {
      setChoosedRate(userRates[0].value);
      formik.setFieldValue("choosedRate", userRates[0].value);
    }

    // setChoosedRate("");

    // Clear form fields by setting the new form values
    //formik.setValues(newFormValues);
  };

  function convertDateFormat(dateString) {
    const mnths = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };

    const dateArray = dateString.split(" ");
    const year = dateArray[3];
    const month = mnths[dateArray[1]];
    const day = dateArray[2];

    return `${year}-${month}-${day}`;
  }

  const getFormattedDate = (date) => formatDisplayDate(date);

  const toggleStartDateDropdown = () => {
    // setIsOpen(!isOpen);
    if (startDatePickerRef.current) {
      setIsOpen(true);
      startDatePickerRef.current.setOpen(true);
    }
  };

  const handleStartDateChange = (date, event) => {
    event.stopPropagation();
    // Set the selected date
    // console.log(date);
    formik.setFieldValue("payFromDate", date);
    setIsOpen(false);
    // Close the date picker dropdown
    if (startDatePickerRef.current) {
      startDatePickerRef.current.setOpen(false);
    }
  };

  const toggleEndDateDropdown = () => {
    setIsOpenEndDate(true);
    if (endDatePickerRef.current) {
      endDatePickerRef.current.setOpen(true);
    }
  };

  const handleEndDateChange = (date, event) => {
    event.stopPropagation();
    // Set the selected date
    formik.setFieldValue("payToDate", date);
    setIsOpenEndDate(false);

    // Close the date picker dropdown
    if (endDatePickerRef.current) {
      endDatePickerRef.current.setOpen(false);
    }
  };

  // const handleSubmit = async (values) => {
  //   if (!userEmail) {
  //     showMessage("Please select a user.");
  //     return;
  //   }

  //   if (!values.payFromDate) {
  //     showMessage("Please enter starting date.");
  //     return;
  //   }
  //   if (!values.payToDate) {
  //     showMessage("Please enter ending date.");
  //     return;
  //   }
  //   if (!values.hours) {
  //     showMessage("Please enter hours worked.");
  //     return;
  //   }

  //   setLoading(true);
  //   values.userId = userId;
  //   values.email = userEmail;
  //   values.payToDateInput = convertDateFormat(values.payToDate.toString());
  //   values.payFromDateInput = convertDateFormat(values.payFromDate.toString());

  //   try {
  //     const response = await fetch(`${apiUrl}/generateInvoice`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(values),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       setInvoiceId(data.data.id);
  //       showMessage(data.message);
  //     } else {
  //       showMessage("Error: " + data.message);
  //     }
  //   } catch (error) {
  //     showMessage("An error occured");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const formik = useFormik({
    initialValues: {
      payFromMonth: "",
      payToMonth: "",
      payRate: "",
      payFromDate: "",
      payToDate: "",
      hours: "",
      minutes: "",
      choosedRate: "",
      Additions: "",
      Deductions: "",
      salary: "",
      paymentType: "",
    },
    validationSchema: yup.object({
      payFromDate: yup
        .string()
        .test(
          "is-before",
          "Starting date must be before Ending date",
          function (value) {
            const { payToDate } = this.parent;
            return (
              !value ||
              !payToDate ||
              moment(value).isBefore(payToDate) ||
              moment(value).isSame(payToDate)
            );
          }
        ),
      payToDate: yup
        .string()
        .test(
          "is-after",
          "Ending date must be after Starting date",
          function (value) {
            const { payFromDate } = this.parent;
            return (
              !value ||
              !payFromDate ||
              moment(value).isAfter(payFromDate) ||
              moment(value).isSame(payFromDate)
            );
          }
        ),
      hours: yup.number(),
      minutes: yup.number(),
      Additions: yup.number(),
      Deductions: yup.number(),
    }),
    //onSubmit: handleSubmit,
  });
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const startDateParam = params.get("startDate");
    const endDateParam = params.get("endDate");
    if (!startDateParam && !endDateParam) return;

    const from = startDateParam ? new Date(startDateParam) : null;
    const to = endDateParam ? new Date(endDateParam) : null;
    if (from && !Number.isNaN(from.getTime())) {
      formik.setFieldValue("payFromDate", from);
    }
    if (to && !Number.isNaN(to.getTime())) {
      formik.setFieldValue("payToDate", to);
    }
  }, [location.search]);

  useEffect(() => {
    if (formik.values.payToDate && formik.values.payFromDate) {
      handleFetchEmployees();
    }
  }, [formik.values.payToDate, formik.values.payFromDate]);

  useEffect(() => {
    if (isReady) {
      handleFetchEmployees();
    }
  }, [isReady]);

  const periodFrom = formik.values.payFromDate
    ? convertDateFormat(formik.values.payFromDate.toString())
    : "";
  const periodTo = formik.values.payToDate
    ? convertDateFormat(formik.values.payToDate.toString())
    : "";

  // An employee can have only one payslip per period: when one exists, load
  // its rows so new rows are saved into it instead of creating a duplicate.
  useEffect(() => {
    const requestId = ++existingLookupRef.current;

    const clearLoadedPayslip = () => {
      if (loadedInvoiceIdRef.current !== null) {
        setFormDataList([]);
        setEditedIndex(null);
        setBtnText("Add");
      }
      loadedInvoiceIdRef.current = null;
      setExistingInvoiceId(null);
    };

    if (!id || !periodFrom || !periodTo) {
      clearLoadedPayslip();
      return;
    }

    const loadExistingPayslip = async () => {
      try {
        const response = await axios.post(`${apiUrl}/getPayslipForPeriod`, {
          userId: id,
          payFromDate: periodFrom,
          payToDate: periodTo,
        });
        if (requestId !== existingLookupRef.current) return;

        const existing = response.data?.data;
        if (!existing) {
          clearLoadedPayslip();
          return;
        }
        if (loadedInvoiceIdRef.current === existing.id) return;

        let existingRows = [];
        try {
          const parsed = JSON.parse(existing.formDataList || "[]");
          existingRows = Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          existingRows = [];
        }

        // Keep rows the user added before the lookup finished, but drop rows
        // that belonged to a previously loaded payslip.
        const keepPendingRows = loadedInvoiceIdRef.current === null;
        setFormDataList((prev) =>
          keepPendingRows ? [...existingRows, ...prev] : existingRows
        );
        setEditedIndex(null);
        setBtnText("Add");
        loadedInvoiceIdRef.current = existing.id;
        setExistingInvoiceId(existing.id);
      } catch (error) {
        if (requestId !== existingLookupRef.current) return;
        console.error("Failed to check existing payslip:", error);
      }
    };

    loadExistingPayslip();
  }, [id, periodFrom, periodTo]);

  const handleClearDateEnd = () => {
    console.log(isOpenEndDate);
    setIsOpenEndDate(0);
    console.log(isOpenEndDate);
  };
  // Fetch employees from the API
  // useEffect(() => {
  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${apiUrl}/getAllUsersForEmployeeInvoice`,
        {
          payFromDate: convertDateFormat(formik.values.payFromDate.toString()),
          payToDate: convertDateFormat(formik.values.payToDate.toString()),
          eligibilityFilter: "payslip",
        }
      );
      setEmployees(response.data.employees);
      setPropertyList(response.data.propertyNames);
      setAdditionsTypeList(response.data.additionsNames);
      setDeductionssTypeList(response.data.deductionsNames);
      setLoading(false);
      //console.log(response.data);
    } catch (error) {
      //console.error("Failed to fetch employees:", error);
    }
  };
  const handleFetchEmployees = () => {
    if (
      formik.values.payToDate &&
      formik.values.payFromDate &&
      formik.values.payToDate.toString() != "" &&
      formik.values.payFromDate.toString() != ""
    ) {
      fetchEmployees();
    }
  };

  // }, [formik.values.payFromDate, formik.values.payToDate]);

  // const formik = useFormik({
  //   initialValues: {
  //     payFromMonth: "",
  //     payToMonth: "",
  //     payRate: "",
  //     payFromDate: "",
  //     payToDate: "",
  //     hours: "",
  //     Additions: "",
  //     Deductions: "",
  //   },
  //   validationSchema: yup.object({
  //     payFromDate: yup
  //       .string()
  //       .test(
  //         "is-before",
  //         "Starting date must be before Ending date",
  //         function (value) {
  //           const { payToDate } = this.parent;
  //           return (
  //             !value ||
  //             !payToDate ||
  //             moment(value).isBefore(payToDate) ||
  //             moment(value).isSame(payToDate)
  //           );
  //         }
  //       ),
  //     payToDate: yup
  //       .string()
  //       .test(
  //         "is-after",
  //         "Ending date must be after Starting date",
  //         function (value) {
  //           const { payFromDate } = this.parent;
  //           return (
  //             !value ||
  //             !payFromDate ||
  //             moment(value).isAfter(payFromDate) ||
  //             moment(value).isSame(payFromDate)
  //           );
  //         }
  //       ),
  //     hours: yup.number(),
  //     minutes: yup.number(),
  //     Additions: yup.number(),
  //     Deductions: yup.number(),
  //   }),
  //   onSubmit: async (values) => {
  //     if (!userEmail) {
  //       showMessage("Please select a user.");
  //       return;
  //     }

  //     if (!values.payFromDate) {
  //       showMessage("Please enter starting date.");
  //       return;
  //     }
  //     if (!values.payToDate) {
  //       showMessage("Please enter ending date.");
  //       return;
  //     }
  //     if (!values.hours) {
  //       showMessage("Please enter hours worked.");
  //       return;
  //     }

  //     setLoading(true);
  //     values.userId = userId;
  //     values.email = userEmail;
  //     values.payToDateInput = convertDateFormat(values.payToDate.toString());
  //     values.payFromDateInput = convertDateFormat(
  //       values.payFromDate.toString()
  //     );
  //     //console.log("Submitting the following data:", values);
  //     try {
  //       const response = await fetch(`${apiUrl}/generateInvoice`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(values),
  //       });
  //       const data = await response.json();
  //       if (response.ok) {
  //         setInvoiceId(data.data.id);
  //         //window.alert(data.message);
  //         showMessage(data.message);
  //       } else {
  //         //window.alert("Error: " + data.message);
  //         showMessage("Error: " + data.message);
  //       }
  //     } catch (error) {
  //       //console.error("Error:", error);
  //       showMessage("An error occured");
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  // });

  const options = [
    ...employees
      .filter(
        (employee) =>
          !employee.hasInvoice ||
          (profileEmployeeId != null &&
            String(employee.id) === String(profileEmployeeId))
      )
      .map((employee) => ({
      value: employee.id || id,
      label: employee.hasInvoice
        ? `${employee.name} (payslip exists)`
        : `${employee.name}`,
      style: {
        //fontWeight: employee.hasInvoice ? "normal" : "bold",
        color: employee.hasInvoice ? "grey" : "inherit",
      },
    })),
  ];

  const propertyOptions = [
    ...propertyList.map((property) => ({
      value: property.NAME,
      label: property.NAME,
    })),
  ];

  const deductionsOptions = [
    ...deductionssTypeList.map((deductionssType) => ({
      value: deductionssType.NAME,
      label: deductionssType.NAME,
    })),
  ];

  const additionsOptions = [
    ...additionsTypeList.map((additionsType) => ({
      value: additionsType.NAME,
      label: additionsType.NAME,
    })),
  ];

  if (!canGeneratePayslip) {
    return <PermissionDialog />;
  }

  return (
    <div className="feedback-parent-container">
      <NavBar />
      <TopNavBar />
      <div className="parent-container-generateInvoice">
        <div className="generate-invoice-admin-header">
          <div className="left-section">
            <h1 className="admin-header-title">
              <span className="admin-card-title-span">Payslip</span>
            </h1>
          </div>
          <div
            className="right-section custompayperiod"
            style={{ marginTop: "12px" }}
          >
            {/* <h1 className="admin-card-title form-heading-text margin-bottom">
                    <span className="admin-card-title-span" style={{marginRight:'50px'}}>Pay Period</span>
                  </h1> */}

            <div className="custom-datepicker">
              <div
                className="form-group-generateInvoice"
                onClick={toggleStartDateDropdown}
              >
                <div className="input-container-generateInvoice input-container-box">
                  <div className="icon-container">
                    <img
                      className="email-icon"
                      src={startingDateIcon}
                      alt="icon"
                    />
                  </div>
                  <div className="generate-invoice-form-input-container generate-invoice-date-input-hidden">
                    <div
                      className={`date-label ${
                        formik.values.payFromDate ? "date-label-fill" : ""
                      }`}
                    >
                      {getFormattedDate(formik.values.payFromDate) || ""}
                    </div>
                    <DatePicker
                      ref={startDatePickerRef}
                      className={`date-picker ${
                        formik.values.payFromDate ? "" : "hidden"
                      }`}
                      selected={formik.values.payFromDate}
                      onChange={handleStartDateChange} // Use the new handler
                      onBlur={formik.handleBlur}
                      shouldCloseOnSelect={true}
                      open={isOpen}
                    />
                    <div
                      className={`${
                        formik.values.payFromDate ? "date-label-filled" : ""
                      }`}
                    >
                      <label htmlFor="Starting Date">Starting Date</label>
                    </div>
                  </div>
                  {formik.touched.payFromDate && formik.errors.payFromDate && (
                    <div className="error-message">
                      {formik.errors.payFromDate}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="custom-datepicker">
              <div
                className="form-group-generateInvoice"
                onClick={toggleEndDateDropdown}
              >
                <div className="input-container-generateInvoice input-container-box">
                  <div className="icon-container">
                    <img
                      className="email-icon"
                      src={endingDateIcon}
                      alt="icon"
                    />
                  </div>
                  <div className="generate-invoice-form-input-container  generate-invoice-date-input-hidden">
                    <div
                      className={`date-label ${
                        formik.values.payToDate ? "date-label-fill" : ""
                      }`}
                    >
                      {getFormattedDate(formik.values.payToDate) || ""}
                    </div>

                    <DatePicker
                      ref={endDatePickerRef}
                      selected={formik.values.payToDate}
                      onChange={handleEndDateChange}
                      onBlur={formik.handleBlur}
                      dropdownMode="select"
                      open={isOpenEndDate}
                      // placeholderText="Ending Date"
                    />
                    <div
                      className={`${
                        formik.values.payToDate ? "date-label-filled" : ""
                      }`}
                    >
                      <label htmlFor="Ending Date">Ending Date</label>
                    </div>
                    {/* <button
                      type="button"
                      onClick={handleClearDateEnd}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        position: 'absolute',
                        right: '10px', 
                        top: '10px' 
                      }}
                    >
                      &times; 
                    </button> */}
                  </div>
                  {formik.touched.payToDate && formik.errors.payToDate && (
                    <div className="error-message">
                      {formik.errors.payToDate}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* <button
              style={{ marginTop: '-15px' }}
              type="button"
              onClick={handleFetchEmployees}
              className="btn-generateInvoice new-btn-generateInvoice"
            >
              Apply
            </button> */}
          </div>

          {/* end date  */}
        </div>
        <div className="container-generateInvoice new-container-generateInvoice">
          <div className="left-panel">
            <div className="input-container-left-generateInvoice border-remove generate-left-panel-top-margin">
              <Tippy
                content="Please select starting and ending date"
                disabled={formik.values.payFromDate && formik.values.payToDate} // Only show when not selected
                placement="top"
              >
                <div className="scrollable-dropdown">
                  <Select
                    id="employeeSelect"
                    placeholder="Choose Employee"
                    options={options}
                    value={
                      options.find((option) => option.value === id) || null
                    }
                    // value={{
                    //   value: userEmail,
                    //   label: userEmail,
                    // }}

                    onFocus={() => setSelectOpen(true)}
                    onBlur={() => setSelectOpen(false)}
                    isDisabled={
                      !(formik.values.payFromDate && formik.values.payToDate)
                    }
                    onChange={(selectedOption) => {
                      if (selectedOption.value === id) return;
                      if (formDataList.length > 0) {
                        setFormDataList([]); // Set formDataList to empty array
                      }
                      loadedInvoiceIdRef.current = null;
                      setExistingInvoiceId(null);
                      setUserIdState(selectedOption.value);
                      formik.setFieldValue("employee", selectedOption.value);
                    }}
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: "50vh",
                        overflowY: "scroll",
                      }),
                      control: (provided) => ({
                        ...provided,
                        width: "41vw",
                        backgroundColor: "#EDF6F0",
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        fontWeight: state.data.style.fontWeight,
                        color: state.data.style.color,
                      }),
                    }}
                    getOptionStyle={(option) => option.style}
                  />
                </div>
              </Tippy>
              <div className="user-detail-main-invoice">
                {user && Object.keys(user).length > 0 ? (
                  <div className="user-detail-inner-div unallign-item width-fourty">
                    <div className=" generate-image-container new-generate-image-container">
                      {!imageURL && ( // If imageUrl is not available
                        <div className="user-image-container image-display-invoice-user">
                          <img src={DefaultEmployeeProfile} alt="User Image" />
                        </div>
                      )}
                      {imageURL && (
                        <div className="user-image-container image-display-invoice-user">
                          <img src={imageURL} alt="User Image" />
                        </div>
                      )}
                    </div>
                    <div className="right-container">
                      <div className="user-detail-text-container user-detail-text-style">
                        <p>User Details</p>
                      </div>

                      <div className="generate-invoice-right-container-user-data padding-left-two">
                        <span className="generate-invoice-user-detail-left-text">
                          Name -
                        </span>
                        <span className="user-particular"> {user.name}</span>
                      </div>
                      <div className="generate-invoice-right-container-user-data padding-left-two">
                        <span className="generate-invoice-user-detail-left-text">
                          Email -
                        </span>
                        <span className="user-particular"> {user.email}</span>
                      </div>
                      <div className="generate-invoice-right-container-user-data padding-left-two">
                        <span className="generate-invoice-user-detail-left-text">
                          Pay Rate -{" "}
                        </span>
                        <span className="user-particular">
                          {" "}
                          ${formatInvoiceAdditions(user.payRate)}/hr
                        </span>
                      </div>
                      <div className="generate-invoice-right-container-user-data padding-left-two">
                        <span className="generate-invoice-user-detail-left-text">
                          Secondary Pay Rate -{" "}
                        </span>
                        <span className="user-particular">
                          {" "}
                          ${formatInvoiceAdditions(user.secondaryPayRate)}/hr
                        </span>
                      </div>
                      <div className="generate-invoice-right-container-user-data padding-left-two">
                        <span className="generate-invoice-user-detail-left-text">
                          Tertiary Pay Rate -{" "}
                        </span>
                        <span className="user-particular">
                          {" "}
                          {user.tertiaryPayRate !== null &&
                          user.tertiaryPayRate !== undefined &&
                          user.tertiaryPayRate !== ""
                            ? `$${formatInvoiceAdditions(user.tertiaryPayRate)}/hr`
                            : "---"}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="select-employye-detail">
                    Please select employee for details
                  </div>
                )}
              </div>
              <div>
                {user && Object.keys(user).length > 0 && (
                  <hr className="invoice-display-separator" />
                )}

                {existingInvoiceId && (
                  <div className="existing-payslip-notice">
                    A payslip already exists for this employee in this period.
                    Its rows are loaded below, and any rows you add will be
                    saved into the same payslip.
                  </div>
                )}
                {formDataList.length > 0 && (
                  <>
                    <InvoiceDisplay
                      formDataList={formDataList}
                      onDelete={handleDeleteEntry}
                      onEdit={handleEditEntry}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "4%",
                      }}
                    >
                      {/* {invoiceId && (
                      <>
                        <Link
                          to="/invoiceDetail"
                          state={invoiceId}
                          className="btn-generateInvoice submit-form-generate"
                        >
                          Show Payslip
                        </Link>
                        
                      </>
                    )} */}
                      <button
                        className="btn-generateInvoice submit-form-generate"
                        onClick={handleDataSubmission}
                      >
                        {existingInvoiceId ? "Update Payslip" : "Generate Payslip"}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="right-panel">
            <div className="card-generateInvoice">
              <div className="card-body-generateInvoice">
                <form
                  // onSubmit={formik.handleSubmit}
                  className="form-container-generateInvoice"
                >
                  <h1 className="admin-card-title form-heading-text margin-bottom">
                    <span className="admin-card-title-span">Form</span>
                  </h1>
                  <div
                    className="form-group-generateInvoice"
                    // onClick={toggleStartDateDropdown}
                  >
                    <div className="input-container-generateInvoice input-container-box">
                      <div className="icon-container">
                        <img
                          className="email-icon"
                          src={propertyIcon}
                          alt="icon"
                        />
                      </div>
                      <Tippy
                        content="Please select starting and ending date"
                        disabled={
                          formik.values.payFromDate && formik.values.payToDate
                        } // Only show when not selected
                        placement="top"
                      >
                        <div className="generate-invoice-form-input-container select-type padding-select-type-left">
                          <Select
                            placeholder={property ? "" : "Select Property"}
                            options={propertyOptions}
                            value={
                              property
                                ? propertyOptions.filter((option) =>
                                    property.includes(option.value)
                                  )
                                : [] // Use an array to handle multiple selected options
                            }
                            isMulti
                            isDisabled={
                              !(
                                formik.values.payFromDate &&
                                formik.values.payToDate
                              )
                            } // Enable multiple selection
                            onFocus={() => setSelectOpen(true)}
                            onBlur={() => setSelectOpen(false)}
                            onChange={(selectedOptions) => {
                              // Convert the selected options into a comma-separated string
                              const selectedValues = selectedOptions
                                .map((option) => option.value)
                                .join(", ");

                              // Update the state and Formik value with the comma-separated string
                              setProperty(selectedValues);
                              formik.setFieldValue(
                                "addressProperty",
                                selectedValues
                              );
                            }}
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                maxHeight: "50vh",
                                overflowY: "scroll",
                              }),
                              control: (provided, state) => ({
                                ...provided,
                                width: "26vw",
                                backgroundColor: "#ffff",
                                border: "none",
                                boxShadow: state.isFocused ? "none" : "none",
                                opacity: !(
                                  formik.values.payFromDate &&
                                  formik.values.payToDate
                                )
                                  ? 0.5
                                  : 1, // Optional: fade out when disabled
                                cursor: !(
                                  formik.values.payFromDate &&
                                  formik.values.payToDate
                                )
                                  ? "not-allowed"
                                  : "pointer",
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                lineHeight: "21px",
                                fontWeight: 300,
                              }),
                            }}
                          />
                        </div>
                      </Tippy>
                    </div>
                  </div>
                  <div className="hours-minutes-container">
                    <div className="form-group-generateInvoice hourly-salary-container">
                      <div className=" input-container-generateInvoice-radio width-full gap-two">
                        <div
                          className="generate-invoice-form-input-container allign-hours-icon margin-left-allign-hours width-eighty"
                          onClick={() => handleRadioClick("hourly")}
                        >
                          <div className=" display-flex align-radio">
                            <input
                              type="radio"
                              id="hourly"
                              name="paymentType"
                              value="hourly"
                              checked={formik.values.paymentType === "hourly"}
                              onChange={formik.handleChange}
                            />
                            <span className="radio-label">Hourly</span>
                          </div>
                          {formik.touched.hours && formik.errors.hours && (
                            <div className="error-message">
                              {formik.errors.hours}
                            </div>
                          )}
                        </div>

                        <div
                          className="generate-invoice-form-input-container small-text margin-left-allign-hours margin-select-type padding-select-type-left"
                          onClick={() => handleRadioClick("salary")}
                        >
                          <div className="display-flex align-radio">
                            <input
                              type="radio"
                              id="salary"
                              name="paymentType"
                              value="salary"
                              checked={formik.values.paymentType === "salary"}
                              onChange={formik.handleChange}
                            />
                            <span className="radio-label">Salary</span>
                          </div>
                        </div>
                        <div
                          className="generate-invoice-form-input-container small-text margin-left-allign-hours margin-select-type padding-select-type-left"
                          onClick={() => handleRadioClick("overtime")}
                        >
                          <div className="display-flex align-radio">
                            <input
                              type="radio"
                              id="overtime"
                              name="paymentType"
                              value="overtime"
                              checked={formik.values.paymentType === "overtime"}
                              onChange={formik.handleChange}
                            />
                            <span className="radio-label">Overtime</span>
                          </div>
                        </div>
                        {formik.touched.minutes && formik.errors.minutes && (
                          <div className="error-message">
                            {formik.errors.minutes}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {formik.values.paymentType === "salary" && (
                    <div className="form-group-generateInvoice">
                      <div className="input-container-generateInvoice input-container-box">
                        <div className="icon-container">
                          <img
                            className="email-icon"
                            src={salaryIcon}
                            alt="icon"
                          />
                        </div>
                        <div className="generate-invoice-form-input-container">
                          <input
                            type="number"
                            min="0"
                            name="salary"
                            pattern="[0-9]*"
                            value={formik.values.salary}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            onWheel={handleWheel}
                            onKeyDown={handleKeyDown}
                            placeholder=""
                            className={
                              shouldApplyFilledClass(formik.values.salary)
                                ? "filled"
                                : ""
                            }
                          />
                          <label htmlFor="salary">Salary</label>
                        </div>
                        {formik.touched.hours && formik.errors.hours && (
                          <div className="error-message">
                            {formik.errors.hours}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {(formik.values.paymentType === "hourly" ||
                    formik.values.paymentType === "overtime") && (
                    <div className="hours-minutes-container">
                      <div className="form-group-generateInvoice">
                        <div className="input-container-generateInvoice display-justify gap-two">
                          <div className="generate-invoice-form-input-container allign-hours-icon margin-left-allign-hours flex-one">
                            <div className="icon-container">
                              <img
                                className="email-icon"
                                src={hoursWorkedIcon}
                                alt="icon"
                              />
                            </div>
                            <div className="input-container-hours-padding">
                              <input
                                type="number"
                                pattern="[0-9]*"
                                min="0"
                                name="hours"
                                value={formik.values.hours}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                onKeyDown={(e) => {
                                  // Prevent ".", ",", "e", "-", "+", etc.
                                  if (
                                    ["e", "E", ".", ",", "+", "-"].includes(
                                      e.key
                                    )
                                  ) {
                                    e.preventDefault();
                                  }
                                  handleKeyDown?.(e); // If you have other key logic
                                }}
                                onWheel={(e) => {
                                  e.target.blur(); // Prevent scroll increment
                                  handleWheel?.(e);
                                }}
                                placeholder=""
                                className={
                                  shouldApplyFilledClass(formik.values.hours)
                                    ? "filled"
                                    : ""
                                }
                              />
                              <label
                                className="label-hoursWorked"
                                htmlFor="hoursWorked"
                              >
                                Hour
                              </label>
                            </div>
                            {formik.touched.hours && formik.errors.hours && (
                              <div className="error-message">
                                {formik.errors.hours}
                              </div>
                            )}
                          </div>

                          <div className="generate-invoice-form-input-container small-text margin-left-allign-hours flex-one margin-select-type padding-select-type-left">
                            <div className="icon-container">
                              <img
                                className="email-icon"
                                src={minutesWorkedIcon}
                                alt="icon"
                              />
                            </div>
                            <div className="input-container-hours-padding">
                              <input
                                type="number"
                                pattern="[0-9]*"
                                min="0"
                                max="59" // ✅ corrected max
                                name="minutes"
                                value={formik.values.minutes}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                onKeyDown={(e) => {
                                  if (
                                    ["e", "E", ".", ",", "+", "-"].includes(
                                      e.key
                                    )
                                  ) {
                                    e.preventDefault();
                                  }
                                  handleKeyDown?.(e);
                                }}
                                onWheel={(e) => {
                                  e.target.blur();
                                  handleWheel?.(e);
                                }}
                                placeholder=""
                                className={
                                  shouldApplyFilledClass(formik.values.minutes)
                                    ? "filled"
                                    : ""
                                }
                              />

                              <label
                                className="label-hoursWorked"
                                htmlFor="minutesWorked"
                              >
                                Min
                              </label>
                            </div>
                          </div>
                          {formik.touched.minutes && formik.errors.minutes && (
                            <div className="error-message">
                              {formik.errors.minutes}
                            </div>
                          )}

                          <div className="generate-invoice-form-input-container small-text margin-left-allign-hours select-type flex-one margin-select-type padding-select-type-left">
                            <div className="icon-container">
                              <img
                                className="email-icon"
                                src={payrateIcon}
                                alt="icon"
                              />
                            </div>

                            <Select
                              placeholder={
                                choosedRate !== null &&
                                choosedRate !== undefined
                                  ? formik.values.paymentType === "overtime"
                                    ? `$${parseFloat(choosedRate).toFixed(
                                        2
                                      )} / hr * 1.5`
                                    : `$${parseFloat(choosedRate).toFixed(
                                        2
                                      )} / hr`
                                  : ""
                              }
                              options={userRates}
                              value={
                                choosedRate !== null &&
                                choosedRate !== undefined
                                  ? {
                                      key: userRates.find(
                                        (option) => option.value === choosedRate
                                      )?.key,
                                      title: userRates.find(
                                        (option) => option.value === choosedRate
                                      )?.title,
                                      value: choosedRate,
                                      label: userRates.find(
                                        (option) => option.value === choosedRate
                                      )?.label,
                                      selectedLabel:
                                        formik.values.paymentType === "overtime"
                                          ? `$${parseFloat(choosedRate).toFixed(
                                              2
                                            )} / hr * 1.5`
                                          : `$${parseFloat(choosedRate).toFixed(
                                              2
                                            )} / hr`,
                                    }
                                  : null
                              }
                              formatOptionLabel={(option, { context }) =>
                                context === "menu"
                                  ? formik.values.paymentType === "overtime"
                                    ? `${option.title} - $${parseFloat(
                                        option.value
                                      ).toFixed(2)} / hr * 1.5`
                                    : option.label
                                  : option.selectedLabel ||
                                    `$${parseFloat(option.value).toFixed(2)} / hr`
                              }
                              // value={{
                              //   value: userEmail,
                              //   label: userEmail,
                              // }}

                              onFocus={() => setSelectOpen(true)}
                              onBlur={() => setSelectOpen(false)}
                              onChange={(selectedOption) => {
                                setChoosedRate(selectedOption.value);
                                formik.setFieldValue(
                                  "choosedRate",
                                  selectedOption.value
                                );
                              }}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  maxHeight: "50vh",
                                  overflowY: "scroll",
                                  minWidth: "18vw",
                                  width: "max-content",
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  width: "12vw",
                                  backgroundColor: "#ffff",
                                  border: "none",
                                  boxShadow: state.isFocused ? "none" : "none",
                                }),
                                option: (provided) => ({
                                  ...provided,
                                  whiteSpace: "nowrap",
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  lineHeight: "21px",
                                  fontWeight: 300,
                                }),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    // </div>
                  )}
                  <div className="hours-minutes-container">
                    <div className="form-group-generateInvoice">
                      <div className="input-container-generateInvoice display-justify gap-two">
                        <div className="generate-invoice-form-input-container allign-hours-icon margin-left-allign-hours flex-one">
                          <div className="icon-container">
                            <img
                              className="email-icon"
                              src={additionsIcon}
                              alt="icon"
                            />
                          </div>
                          <div className="input-container-hours-padding ">
                            <input
                              type="number"
                              pattern="[0-9]*"
                              min="0"
                              name="Additions"
                              value={formik.values.Additions}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              onKeyDown={handleKeyDown}
                              placeholder=""
                              onWheel={handleWheel}
                              //className={formik.values.Additions ? 'filled' : ''}
                              className={
                                shouldApplyFilledClass(formik.values.Additions)
                                  ? "filled"
                                  : ""
                              }
                            />
                            <label
                              className="label-hoursWorked"
                              htmlFor="Additions"
                            >
                              Additions
                            </label>
                          </div>
                          {formik.touched.Additions &&
                            formik.errors.Additions && (
                              <div className="error-message">
                                {formik.errors.Additions}
                              </div>
                            )}
                        </div>

                        <div className="generate-invoice-form-input-container small-text margin-left-allign-hours select-type flex-one margin-select-type padding-select-type-left">
                          <div className="icon-container">
                            <img
                              className="email-icon"
                              src={additionsIcon}
                              alt="icon"
                            />
                          </div>

                          <Select
                            placeholder={additionsType ? "" : "Addition Type"}
                            options={additionsOptions}
                            value={
                              additionsType
                                ? options.find(
                                    (option) => option.value === additionsType
                                  )
                                : ""
                            }
                            // value={{
                            //   value: userEmail,
                            //   label: userEmail,
                            // }}

                            onFocus={() => setSelectOpen(true)}
                            onBlur={() => setSelectOpen(false)}
                            onChange={(selectedOption) => {
                              setAdditionsType(selectedOption.value);
                              formik.setFieldValue(
                                "additionsType",
                                selectedOption.value
                              );
                            }}
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                maxHeight: "50vh",
                                overflowY: "scroll",
                              }),
                              control: (provided, state) => ({
                                ...provided,
                                width: "12vw",
                                backgroundColor: "#ffff",
                                border: "none",
                                boxShadow: state.isFocused ? "none" : "none",
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                lineHeight: "21px",
                                fontWeight: 300,
                              }),
                            }}
                          />
                        </div>
                        {/* {formik.touched.minutes &&
                              formik.errors.minutes && (
                                <div className="error-message">
                                  {formik.errors.minutes}
                                </div>
                              )} */}
                      </div>
                    </div>
                  </div>
                  <div className="hours-minutes-container">
                    <div className="form-group-generateInvoice">
                      <div className="input-container-generateInvoice display-justify gap-two">
                        <div className="generate-invoice-form-input-container allign-hours-icon margin-left-allign-hours flex-one">
                          <div className="icon-container">
                            <img
                              className="email-icon"
                              src={deductionsIcon}
                              alt="icon"
                            />
                          </div>
                          <div className="input-container-hours-padding">
                            <input
                              type="number"
                              pattern="[0-9]*"
                              min="0"
                              name="Deductions"
                              value={formik.values.Deductions}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              onKeyDown={handleKeyDown}
                              placeholder=""
                              onWheel={handleWheel}
                              className={
                                shouldApplyFilledClass(formik.values.Deductions)
                                  ? "filled"
                                  : ""
                              }
                              // className={formik.values.Deductions ? 'filled' : ''}
                            />
                            <label
                              id="label-deduction-margin"
                              className="label-hoursWorked"
                              htmlFor="Deductions"
                            >
                              Deductions
                            </label>
                          </div>
                          {formik.touched.Deductions &&
                            formik.errors.Deductions && (
                              <div className="error-message">
                                {formik.errors.Deductions}
                              </div>
                            )}
                        </div>

                        <div className="generate-invoice-form-input-container small-text margin-left-allign-hours select-type flex-one margin-select-type padding-select-type-left">
                          <div className="icon-container">
                            <img
                              className="email-icon"
                              src={deductionsIcon}
                              alt="icon"
                            />
                          </div>
                          <Select
                            placeholder={deductionsType ? "" : "Deduction Type"}
                            options={deductionsOptions}
                            value={
                              deductionsType
                                ? options.find(
                                    (option) => option.value === deductionsType
                                  )
                                : ""
                            }
                            onFocus={() => setSelectOpen(true)}
                            onBlur={() => setSelectOpen(false)}
                            onChange={(selectedOption) => {
                              setdeductionsType(selectedOption.value);
                              formik.setFieldValue(
                                "deductionsType",
                                selectedOption.value
                              );
                            }}
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                maxHeight: "50vh",
                                overflowY: "scroll",
                              }),
                              control: (provided, state) => ({
                                ...provided,
                                width: "12vw",
                                height: "2vh",

                                backgroundColor: "#ffff",
                                border: "none",
                                boxShadow: state.isFocused ? "none" : "none",
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                fontFamily: "Montserrat",
                                fontSize: "13px",
                                lineHeight: "21px",
                                fontWeight: 300,
                              }),
                            }}
                          />
                        </div>
                        {formik.touched.minutes && formik.errors.minutes && (
                          <div className="error-message">
                            {formik.errors.minutes}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {loading && <LoaderForm />}{" "}
                  {/* Show loader if loading is true */}
                  {message && (
                    // <div className="custom-popup">
                    //   {message}
                    // </div>
                    <div className="custom-modal">
                      <div className="modal-content">{message}</div>
                    </div>
                  )}
                  <div className="text-allign-centre">
                    <div>
                      <button
                        type="button"
                        onClick={handleAddData}
                        className="btn-generateInvoice new-btn-generateInvoice"
                      >
                        {btnText}
                      </button>
                    </div>
                    <div className="generate-btn-margin">
                      {/* <button
                        type="submit"
                        className="btn-generateInvoice new-btn-generateInvoice"
                      >
                        Generate
                      </button> */}
                    </div>

                    {/* {invoiceId && (
                      <>
                        <Link
                          to="/invoiceDetail"
                          state={invoiceId}
                          className="show-invoice-btn"
                        >
                          Show Payslip
                        </Link>
                        
                      </>
                    )} */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateInvoice;
